import { useMemo } from 'react'

import { NestedDropdown } from '@swaggerhub-portal/component-library'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { OpenAPI2Definition, OpenAPI3Definition } from '~/types/api.definitions'
import { GENERATOR_SPEC_TYPE, GeneratorLanguages } from '~/types/code.generator'
import { API_FILE_TYPES, downloadApi } from '~/utils/shared/downloadApi'

const GenerateCodeLink = ({ lang, type, productId, path }: {
  lang: string, type: GENERATOR_SPEC_TYPE, productId?: string, path?: string
}) =>
  <Link className="block w-full text-left px-4 py-1.5" key={lang} to={`/services/api/generatecode?lang=${lang}&type=${type}&productId=${productId}&path=${path}`} reloadDocument={true}>
    {lang}
  </Link>

export const GenerateCodeDropdown = ({ generatorLanguages, definition, title, productId, path, accentColor }:
  {
    definition: OpenAPI2Definition | OpenAPI3Definition,
    generatorLanguages: GeneratorLanguages,
    title: string,
    productId?: string,
    path?: string,
    accentColor?: string,
  }) => {
  const { t } = useTranslation()

  const menuItems = useMemo(() => [
    {
      name: t('components.ui.apiViewer.generateCode.options.clientSDK'),
      options: generatorLanguages.clients.map(el => <GenerateCodeLink key={el} lang={el} type={GENERATOR_SPEC_TYPE.CLIENT} productId={productId} path={path} />),
    },
    {
      name: t('components.ui.apiViewer.generateCode.options.serverStub'),
      options: generatorLanguages.servers.map(el => <GenerateCodeLink key={el} lang={el} type={GENERATOR_SPEC_TYPE.SERVER} productId={productId} path={path} />),
    },
    {
      name: t('components.ui.apiViewer.generateCode.options.documentation'),
      options: generatorLanguages.documentations.map(el => <GenerateCodeLink key={el} lang={el} type={GENERATOR_SPEC_TYPE.DOCUMENTATION} productId={productId} path={path} />),
    },
    {
      name: t('components.ui.apiViewer.downloadApi.label'),
      options: [
        API_FILE_TYPES.JSON,
        API_FILE_TYPES.YAML,
      ]
    }
  ], [productId])

  const onClickDropdown = (name: string) => {
    if (name === API_FILE_TYPES.JSON || name === API_FILE_TYPES.YAML) {
      downloadApi(name, definition, title)
    }
  }

  return (
    <NestedDropdown
      menuItems={menuItems}
      onClick={onClickDropdown}
      dropdownButton={t('components.ui.apiViewer.generateCode.label')}
      accentColor={accentColor}
    />
  )
}